import { Input } from '@enterprise-ui/canvas-ui-react';
import React__default from 'react';
import { SINGLE_ROW_SELECT, MULTIPLE_ROW_SELECT } from './constants.js';
import { getSelectedRow } from './helpers.js';

var SelectionCell = function SelectionCell(_ref) {
  var dataTestId = _ref.dataTestId,
    onRowSelect = _ref.onRowSelect,
    rowId = _ref.rowId,
    rowSelection = _ref.rowSelection,
    selectedRows = _ref.selectedRows,
    tableName = _ref.tableName;
  if (!rowId) {
    console.error('Hey Canvas User! Table row selection requires a unique row id.');
  }
  var hasRowSelection = rowSelection === SINGLE_ROW_SELECT || rowSelection === MULTIPLE_ROW_SELECT;
  var isChecked = function isChecked(selectedRows, rowId) {
    if (Array.isArray(selectedRows)) {
      return selectedRows.includes(rowId);
    }
  };
  return hasRowSelection && /*#__PURE__*/React__default.createElement("td", {
    className: "C-TableAdvanced__bodyCell --showGrid",
    "data-testid": dataTestId ? "".concat(dataTestId, "-").concat(rowId, "-selection-cell") : null
  }, /*#__PURE__*/React__default.createElement(Input.Checkbox, {
    checked: isChecked(selectedRows, rowId),
    "data-testid": dataTestId ? "".concat(dataTestId, "-").concat(rowId, "-selection-cell-checkbox") : null,
    id: "".concat(tableName, "-row-").concat(rowId),
    onChange: function onChange(event) {
      onRowSelect(getSelectedRow(selectedRows, rowId, event.target.checked));
    }
  }));
};

export { SelectionCell as default };
